import {
    createApp
} from 'vue'
import App from './App.vue'
// 引入axios
import axios from 'axios';
// 引入vuex
import store from './store/index.js'
// 引入路由
import router from './router/index'
//引入element-plus组件及图标
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ELIcons from '@element-plus/icons-vue'
// 全局注入常量数据
import constGlobal from './common/global.js'
// 拖拽弹窗，在需要用到拖拽功能的弹窗标签上加v-dialogDrag
import dialogDrag from './common/dialogDrag.js'
// 引入自定义样式，覆盖element样式
import './assets/css/global.css'
import $ from 'jquery'
// 公共组件使用--为 UMD 组件库挂载全局依赖
import * as Vue from 'vue';
import * as VueRouter from 'vue-router';
import * as Vuex from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';

window.Vue = Vue;
window.VueRouter = VueRouter;
window.Vuex = Vuex;
window.ElementPlus = ElementPlus;
window.ElMessage = ElMessage;
window.ElMessageBox = ElMessageBox;

// 挂载 store 和 router 供远程组件使用
window.$store = store;
window.$router = router;
// 公共组件使用结束--
// 全局按钮组件
import operateButton from "@/components/operateButton/buttonGroup.vue";

window.jQuery = $
window.$ = $
const app = createApp(App)
app.component('operateButton',operateButton)

// 全局注册icon
for (let iconName in ELIcons) {
    app.component(iconName, ELIcons[iconName])
}
app.use(store).use(router).use(dialogDrag).use(ElementPlus, {
    size: 'default'
}).mount('#app')
app.config.globalProperties.$axios = axios; //配置axios的全局引用
app.config.productionTip = false;
// 挂载到实例上 vue3废除了prototype
app.config.globalProperties.$constGlobal = constGlobal;
//去掉控制台的warn信息
app.config.warnHandler = () => null